module.exports = __webpack_public_path__ + "img/CM-MR-CA-Mazda-Modern.90a925f5.jpeg";